"use client";
import { useRouter } from "next/navigation";
import { Typography } from "@mui/material";

import { useStore, observer } from "../../../../service/mobx";
import ChipFilter from "../../../Chip/Filter";

function SearchFilterChip({ entityName, label, href, Icon }) {
  const { analytics, search } = useStore();
  const router = useRouter();
  const selected = search.filterType === label;

  return (
    <ChipFilter
      selected={selected}
      label={label}
      StartIcon={selected ? undefined : Icon}
      endIcon={<Count type={label} />}
      onClick={() => {
        const toggled = !selected;

        search.updateUrlParams(
          router,
          {
            type: toggled ? [href] : undefined,
            q: search.userInput ? [search.userInput] : undefined
          },
          true
        );
        analytics.track.event("Search Filter", {
          entity: { type: entityName, value: toggled }
        });
      }}
    />
  );
}

export default observer(SearchFilterChip);

export const Count = observer(function Count({ type, count }) {
  const { utilities, search } = useStore();
  const hide = search.loadingCount;

  count ??= search.count[type];

  return count === undefined ? null : (
    <Typography
      variant="labelSm"
      color="var(--secondary-on-container)"
      bgcolor="var(--secondary-container)"
      sx={theme => ({
        ...(hide
          ? { fontSize: 0, opacity: 0 }
          : { px: 0.5, pt: 0.25, mr: -0.5, ml: 1 }),

        borderRadius: "var(--shape-xs-round)",
        transition: theme.transitions.create("all")
      })}
    >
      {utilities.formatNumber(count)}
    </Typography>
  );
});
